import React from 'react';
import './tabs.css';

/**
 * Tabs — `items` is [{id, label, badge?}]. Controlled, so the parent
 * owns the active id (screens often mirror it into the URL).
 */
export default function Tabs({ items = [], active, onChange }) {
  return (
    <div className="ui-tabs" role="tablist">
      {items.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={active === t.id}
          className={`ui-tab${active === t.id ? ' is-active' : ''}`}
          onClick={() => onChange && onChange(t.id)}
        >
          {t.label}
          {t.badge != null && <span className="ui-tab-badge">{t.badge}</span>}
        </button>
      ))}
    </div>
  );
}
